export default __webpack_public_path__ + "static/media/GFGlogo.c395c76d.png";